import { useState } from 'react';
import { Btn, H5 } from '../../../../../AbstractElements';
import { MofiSignUp, OpenModalForMofi } from '../../../../../utils/Constant';
import CommonModal from '../../Common/CommonModal';
import OpenModalForm from './OpenModalForm';

const OpenModalMofi = () => {
  const [openModal, setOpenModal] = useState(false);
  const openModalToggle = () => setOpenModal(!openModal);
  return (
    <>
      <Btn color="primary" onClick={openModalToggle}>{OpenModalForMofi}</Btn>
      <CommonModal isOpen={openModal} toggle={openModalToggle} modalBodyClassName="p-0" heading="wool SIGN-UP">
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <H5 className="modal-header justify-content-center border-0">{MofiSignUp}</H5>
          <OpenModalForm modal={openModalToggle}/>
        </div>
      </CommonModal>
    </>
  )
}

export default OpenModalMofi